export default class Search {
    constructor(parent) {
        this.el = parent.el.querySelector('.nav__search');
        if (this.el) {
            this.page = document.querySelector('#page');
            this.toggle = this.el.querySelector('.search--toggle');
            this.search = this.el.querySelector('.search');
            this.nav = parent.el;
            this.bind();
        }
    }

    bind() {
        this.toggle.addEventListener('click', (e) => {
            const isVisible = this.search?.classList.contains("visible");

            if (isVisible === undefined) {
                return;
            }

            this.toggle.setAttribute("aria-expanded", !isVisible);
            this.search.classList.toggle("visible", !isVisible);
            this.nav?.classList.toggle("search-open", !isVisible);
            this.page?.classList.toggle("push-top", !isVisible);
        });
    }
}
